import React from 'react';
import styled from 'styled-components';
import { Activity } from '../types';
import { COLORS } from '../styles/constants';
import { CloseButton } from '../styles/styled';

const Modal = styled.div<{ $isOpen: boolean }>`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  display: ${({ $isOpen }) => ($isOpen ? 'flex' : 'none')};
  justify-content: center;
  align-items: center;
  z-index: 1100;
`;

const Content = styled.div`
  background: ${COLORS.BACKGROUND_PRIMARY};
  border-radius: 8px;
  width: 90%;
  max-width: 800px;
  max-height: 90vh;
  overflow-y: auto;
  position: relative;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
`;

const Header = styled.div`
  padding: 1.5rem;
  border-bottom: 1px solid ${COLORS.BORDER_LIGHT};
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  position: sticky;
  top: 0;
  background: ${COLORS.BACKGROUND_PRIMARY};
  z-index: 1;
`;

const HeaderContent = styled.div`
  flex: 1;
`;

const Subject = styled.h3`
  margin: 0;
  margin-bottom: 4px;
  color: ${COLORS.TEXT_PRIMARY};
  font-size: 1.25rem;
`;

const Recipient = styled.div`
  font-size: 14px;
  color: ${COLORS.TEXT_SECONDARY};
`;

const Body = styled.div`
  padding: 1.5rem;
  color: ${COLORS.TEXT_PRIMARY};
  font-size: 14px;
  line-height: 1.5;

  img {
    max-width: 100%;
    height: auto;
  }

  a {
    color: ${COLORS.PRIMARY};
    text-decoration: none;

    &:hover {
      text-decoration: underline;
    }
  }
`;

interface EmailPreviewProps {
  emailContent: NonNullable<Activity['emailContent']> | null;
  onClose: () => void;
}

export const EmailPreview: React.FC<EmailPreviewProps> = ({
  emailContent,
  onClose,
}) => {
  if (!emailContent) return null;

  return (
    <Modal $isOpen={!!emailContent} onClick={onClose}>
      <Content onClick={(e) => e.stopPropagation()}>
        <Header>
          <HeaderContent>
            <Subject>{emailContent.subject}</Subject>
            <Recipient>To: {emailContent.to}</Recipient>
          </HeaderContent>
          <CloseButton onClick={onClose}>
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor">
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M6 18L18 6M6 6l12 12"
              />
            </svg>
          </CloseButton>
        </Header>
        <Body dangerouslySetInnerHTML={{ __html: emailContent.html }} />
      </Content>
    </Modal>
  );
};
